import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  email: "",
  firstName: "",
  lastName: "",
  businesses: [],
  farmsBusinesses: [],
};

const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.email = action.payload.email;
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
    },
    setBusinesses: (state, action) => {
      state.businesses = action.payload;
    },
    setFarmsBusinesses: (state, action) => {
      state.farmsBusinesses = action.payload;
    },
  },
});

export const { setUser, setBusinesses, setFarmsBusinesses } =
  globalSlice.actions;
export default globalSlice.reducer;
